export default __webpack_public_path__ + "static/media/videoStop.021e428f.svg";